import './Barrierefreiheit.css';
import {useNavigate} from "react-router-dom";
import {Button} from "@radix-ui/themes";

function Barrierefreiheit() {

    const navigate = useNavigate();

    const onZurueckClick = () => {
        navigate('/');
    }

    const barrierefreiheitContent = (
        <main aria-labelledby="heading-barrierefreiheit">
            <h1 id="heading-barrierefreiheit" className="content-container-header">Erklärung zur Barrierefreiheit</h1>
            <div className="barrierefreiheit-content">
                <p>
                    Das Landesamt für Umwelt ist bemüht, die Website https://bisbokat.rlp-umwelt.de barrierefrei
                    zugänglich zu machen. Rechtsgrundlage sind das Inklusionsgesetz Rheinland-Pfalz (InklG RP) und die
                    Barrierefreie-Informationstechnik-Verordnung Rheinland-Pfalz (BITV-RP).
                </p>
                <p>Diese Erklärung wurde am 17.11.2025 erstellt.</p>

                <section aria-labelledby="section-vereinbarkeit-bitv-rp">
                    <h2 id="section-vereinbarkeit-bitv-rp">Stand der Vereinbarkeit mit den Anforderungen der
                        BITV-RP</h2>

                    <p>Diese Website ist mit der BITV-RP teilweise vereinbar. Die Zugänglichkeit wurde in einem
                        unabhängigen BITV-Test nicht überprüft.
                    </p>
                    <strong>Nachfolgende Inhalte sind nur eingeschränkt zugänglich. Eine Verbesserung der Zugänglichkeit
                        ist zeitnah geplant.</strong>
                    <ul>
                        <li>
                            Die Texte zu den wesentlichen Inhalten des Angebotes, zur Navigation sowie zur Erklärung
                            zur Barrierefreiheit sind noch nicht in Leichter Sprache verfügbar. Damit sind diese Seiten
                            mit dem Erfolgskriterium der WCAG 3.1.3 (Unübliche Worte), 3.1.4 (Abkürzungen) sowie 3.1.5
                            (Leselevel) nicht vereinbar.
                        </li>
                        <li>
                            Die Texte zu den wesentlichen Inhalten des Angebotes, zur Navigation sowie zur Erklärung zur
                            Barrierefreiheit sind noch nicht in Deutscher Gebärdensprache verfügbar. Damit sind diese
                            Seiten mit dem Erfolgskriterium 1.2.6 (Gebärdensprache) nicht vereinbar.
                        </li>
                    </ul>

                    <strong>Die nachstehend aufgeführten Inhalte sind aus folgenden Gründen nicht barrierefrei:</strong>
                    <p>a) Unvereinbarkeit mit der BITV-RP</p>
                    <ul>
                        <li>Grafiken und Schalter oder andere Bedienelemente liegen teilweise noch ohne Beschriftung
                            vor. Damit ist diese Seite nicht mit dem Erfolgskriterium 1.1.1 (Nicht-Text-Inhalte)
                            vereinbar.
                        </li>
                        <li>
                            Es kann Farb-Kombinationen geben, in denen Kontraste nicht vollständig die Anforderungen
                            der BITV-RP erfüllen. (Erfolgskriterium der WCAG 1.4.3. - Kontrast Minimum).
                        </li>
                        <li>
                            Die Navigation ist teilweise nur mit der Maus vollumfänglich bedienbar und erfüllt somit
                            das Erfolgskriterium 2.1.1. (Tastatur) nicht vollständig.
                        </li>
                        <li>
                            Es gibt vereinzelt Formularfelder ohne zugehöriges Label (Erfolgskriterium 3.3.2 –
                            Beschriftungen).
                        </li>
                        <li>
                            Vereinzelt können PDF-Dokumente nicht barrierefrei sein.
                        </li>
                    </ul>
                    <p>b) Die folgenden Inhalte fallen nicht in den Anwendungsbereich der anwendbaren
                        Rechtsvorschriften:
                    </p>
                    <ul>
                        <li>aufgezeichnete zeitbasierte Medien, die vor dem 23. September 2020 veröffentlicht wurden
                        </li>
                        <li>ggf. live übertragene zeitbasierte Medien</li>
                    </ul>
                    <p>Dateiformate von Büroanwendungen, die vor dem 23. September 2018 veröffentlicht wurden, es sei
                        denn, diese Inhalte sind für die aktiven Verwaltungsverfahren der von der betreffenden
                        öffentlichen Stelle wahrgenommenen Aufgaben erforderlich.</p>
                </section>

                <section aria-labelledby="section-feedback-kontakt">
                    <h2 id="section-feedback-kontakt">Feedback und Kontakt</h2>
                    <p>
                        Sollten Ihnen Mängel in Bezug auf die barrierefreie Gestaltung von&nbsp;
                        <a href="https://bisbokat.rlp-umwelt.de/" target="_blank" rel="noreferrer">
                            https://bisbokat.rlp-umwelt.de/</a> auffallen, können Sie über unser Kontaktformular oder
                        per Mail jederzeit mit uns in Verbindung treten.
                    </p>
                    <address>
                        Stabsstelle Planung und Information<br/>
                        Landesamt für Umwelt Rheinland-Pfalz<br/>
                        Kaiser-Friedrich-Straße 7<br/>
                        55116 Mainz<br/>
                    </address>
                    <a href="mailto:presse@lfu.rlp.de">presse@lfu.rlp.de</a><br/><br/>
                    <p>
                        Zum <a href="https://lfu.rlp.de/ueber-uns/kontakt" target="_blank" rel="noreferrer">
                        Kontaktformular</a>
                    </p>
                </section>

                <section aria-labelledby="section-durchsetzungsstelle">
                    <h2 id="section-durchsetzungsstelle">Durchsetzungsstelle</h2>
                    <p>Sollten Sie nach Ihrer Anfrage bei „Feedback und Kontakt“ der Ansicht sein, durch eine nicht
                        ausreichende barrierefreie Gestaltung von <a href="https://bisbokat.rlp-umwelt.de/"
                                                                     target="_blank"
                                                                     rel="noreferrer">https://bisbokat.rlp-umwelt.de/</a>
                        &nbsp;benachteiligt zu sein, können Sie sich an die Landesbeauftragte für die Belange
                        behinderter Menschen wenden:
                    </p>
                    <address>
                        Ellen Kubica<br/>
                        Landesbeauftragte für die Belange von Menschen mit Behinderung<br/>
                        Ministerium für Arbeit, Soziales, Transformation und Digitalisierung des Landes Rheinland-Pfalz
                        <br/>
                        Bauhofstraße 9<br/>
                        55116 Mainz<br/>
                    </address>
                    Tel.: 06131 16 5342<br/>
                    Fax: 06131 16175342<br/>
                    <a href="mailto:durchsetzungsstelle@mastd.rlp.de">durchsetzungsstelle(at)mastd.rlp.de</a><br/>
                    <a href="https://www.lb.rlp.de" target="_blank" rel="noreferrer">www.lb.rlp.de</a><br/><br/>
                    <p><a href="https://behindertenbeauftragte.rlp.de/ueber-uns/kontakt" target="_blank"
                          rel="noreferrer">Kontaktformular</a>
                    </p>
                </section>

                <Button id="btn-zurueck-anmeldung" onClick={onZurueckClick} aria-label="Zurück zur Anmeldeseite">
                    Zurück zur Anmeldung
                </Button>
            </div>
        </main>
    );

    return (
        <div className="barrierefreiheit-container white">
            {barrierefreiheitContent}
        </div>
    );
}

export default Barrierefreiheit;
